module.exports = __webpack_public_path__ + "static/media/australia_mototurismo_1.c83dd532.jpg";